
import React from 'react';
import { NikoFacilityOrderConfirmationModalTemplate } from 'themes/application/niko-facility-order/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { NikoFacilityOrderConfirmationModalStore } from 'application/niko-facility-order/stores';

@setCurrentView((rootStore, componentProps) => new NikoFacilityOrderConfirmationModalStore(rootStore, componentProps), 'nikoFacilityOrderConfirmationModalStore')
@observer
class NikoFacilityOrderConfirmationModal extends React.Component {
    render() {
        return <NikoFacilityOrderConfirmationModalTemplate {...this.props} />
    }
}

export default NikoFacilityOrderConfirmationModal;
